/**
 * What a RemoteTransform3D or RemoteTransform2D's class and flags decide about a push: the class
 * its target must be, the family a move of the target reaches, and whether a push moves or
 * notifies the target. The RemoteTransform pass and the relay cycle check both read it.
 */
export const RELAY_CLASSES = {
    RemoteTransform3D: { space: 'Node3D', reached: 'Node3D' },
    RemoteTransform2D: { space: 'Node2D', reached: 'CanvasItem' },
};
export function flagsAnyPart({ updatePosition, updateRotation, updateScale }) {
    return updatePosition || updateRotation || updateScale;
}
export function flagsEveryPart({ updatePosition, updateRotation, updateScale }) {
    return updatePosition && updateRotation && updateScale;
}
/**
 * Whether a push sets the target's transform, which notifies the target's listeners. With no part
 * flagged, a 3D relay sets the target's own transform back (`remote_transform_3d.cpp:71-97`), and
 * a 2D relay returns before it sets anything (`remote_transform_2d.cpp:63-65`).
 */
export function pushSetsTarget(space, flags) {
    return space === 'Node3D' || flagsAnyPart(flags);
}
//# sourceMappingURL=relayRules.js.map